var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_c('modals-container'),_c('p',{staticClass:"credits caption text-gray-6"},[_vm._v("created by michaelaangelaaustria@gmail.com © "+_vm._s(_vm.currentYear))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }